// removed by extract-text-webpack-plugin
module.exports = {"topWrap":"qempo_ErrorLinkModal_topWrap-2s2Vpqh","textWrap":"qempo_ErrorLinkModal_textWrap-3QbEcWq","title":"qempo_ErrorLinkModal_title-2YcVRA9","contentWrap":"qempo_ErrorLinkModal_contentWrap-2FWXUWr","textContent":"qempo_ErrorLinkModal_textContent-2fY7SD-","buttonWrap":"qempo_ErrorLinkModal_buttonWrap-2Pq8qWA"};


//////////////////
// WEBPACK FOOTER
// ./src/modules/new-order/ProductStep/components/NewProductForm/ErrorLinkModal/ErrorLinkModal.scss
// module id = 1674
// module chunks = 0